import { Dispatch, SetStateAction, useCallback } from 'react'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { twinFetchPostText } from '../../../../../utils/globals/data'
import { calculateVatSupportedLineAmounts } from '@teinor/erp/prices/accounting/vatSupported'
import { getPreparePricesConfigParam } from '../../../../../utils/reducers/getters'
import { CalculateParamsTy } from '../../../../../baseComponents/Displays/DisplayPrice/types'
import { InputTableLayoutData, InputTableURLsTable } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { TableData } from '../../../../../baseComponents/TwinTable/types'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { TableWithoutVirtualListingRowProps } from '../../../../../baseComponents/TwinTable/TableWithoutVirtualListing/types'

export const useVatLayoutTableRender = () => {
    const addButtonRowRender = useCallback((props: TableWithoutVirtualListingRowProps, addNewProductLine: () => void) => {
        if (!props.style) {
            props.style = {}
        }
        return (
            <div {...props}>
                <div className=' table_row flex items-center justify-center w-full bg-gray-EF add_product_row cursor-pointer input_table_header_row' onClick={addNewProductLine}>
                    <span>+<span className='ml-5'><TwinTrans transKey='addLine'>Añadir fila</TwinTrans></span></span>
                </div>
            </div>
        )
    }, [])

    return { addButtonRowRender}
}

export interface OnChangeVatLayoutTableLogicProps {
    setCompleteData: Dispatch<SetStateAction<InputTableLayoutData | null>>
    getCompleteData: (vat?: TableData) => Promise<void>
    inputTableURLs: InputTableURLsTable
}

export const useOnChangeVatLayoutTableLogic = ({ inputTableURLs, getCompleteData, setCompleteData}: OnChangeVatLayoutTableLogicProps) => {    
    const onChangeTotals = useCallback(async (rowIndex: number, keyValue: string, value: string) => {
        let myRow: { [fieldName: string]: any } = {}
        setCompleteData((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            if (!copyOld) {
                return null
            }
            if (copyOld?.tableData) {
                copyOld.tableData[rowIndex][keyValue] = value
                const myLine = copyOld?.tableData[rowIndex]
                const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
                const prices = calculateVatSupportedLineAmounts(
                    {
                        ...myLine, 
                    },
                    calculateParams
                )
                copyOld.tableData[rowIndex] = { 
                    ...myLine, 
                    ...prices,
                    [keyValue]: value
                }
                myRow = {
                    ...myRow,
                    id: myLine.id,
                    [keyValue]: value,
                    ...prices
                }
                return { ...copyOld }
            }
            return { ...copyOld }
        })
        if (myRow['rowPriceWithoutTax'] === '') {
            myRow['rowPriceWithoutTax'] = 0
        }
        if (myRow['taxUsed'] === '') {
            myRow['taxUsed'] = 0
        }
        return myRow
    }, [setCompleteData])
    
    const onChangeTotalsFetch = useCallback(async (rowIndex: number, keyValue: string, value: string) => {
       const myRow = await onChangeTotals(rowIndex, keyValue, value )
        await twinFetchPostText(inputTableURLs.updateData, { ...myRow })
    }, [ inputTableURLs, onChangeTotals])

    const onChange = useCallback(async (rowIndex: number, keyValue: string, value: string) => {
        let myRow: { [fieldName: string]: any } = {}
        setCompleteData((old) => {
            if (!old) {
                return null
            }
            if (old?.tableData) {
                old.tableData[rowIndex][keyValue] = value
                const myLine = old.tableData[rowIndex]
                myRow = {
                    id: myLine.id,
                    [keyValue]: value
                }
            }
            return { ...old }
        })
        return myRow
    }, [setCompleteData])
    const onChangeFetch = useCallback(async (rowIndex: number, keyValue: string, value: string) => {
        const myRow = await onChange(rowIndex, keyValue, value)
        await twinFetchPostText(inputTableURLs.updateData, { ...myRow })
    }, [inputTableURLs, onChange])

    const onAddNewLine = useCallback(async () => {
        const update = await twinFetchPostText(inputTableURLs.createData[0], { ...inputTableURLs.createData[1] })
        if (update) {
            getCompleteData()
        }
    }, [getCompleteData, inputTableURLs])

    const onChangeUpdate = useCallback(async () => {
        getCompleteData()
    }, [ getCompleteData])

    const deleteLine = useCallback(async (id: number) => {
        let myUpdate: TwinDictionary = {}
        setCompleteData((old: any) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            if (!copyOld) {
                return null
            }
            if (copyOld?.tableData) {
                for (const key in copyOld?.tableData) {
                    const line = copyOld?.tableData[key]
                    if (line.id === id) {
                        const intKey = parseInt(key)
                        copyOld.tableData.splice(intKey, 1)
                        copyOld.originalTableData.splice(intKey, 1)
                        break
                    }
                }
            }
            return { ...copyOld }
        })
        await twinFetchPostText(inputTableURLs.delete, {
            id,
            ...myUpdate
        })
    }, [setCompleteData, inputTableURLs.delete])

    return { onChangeTotals, onChangeTotalsFetch, onChange, onChangeFetch, onChangeUpdate, onAddNewLine, deleteLine}
}